import _ from "lodash";
/**
 * @description Function to set the inital value for the form
 * @param {*} caseObj
 * @param {*} menuItems
 * @param {*} searchParams
 */
export const setInitalFormValue = (caseObj, menuItems, searchParams) => {
  const subscriptionType =
    caseObj?.subscriptionType?.toLowerCase() ||
    caseObj?.subscriptionKind?.toLowerCase() ||
    "normal";
  const initialState = {
    title: "",
    claimValue: "",
  };
  return {
    requestedMediators: setInitialMediator(caseObj),
    agreement: false,
    claimantPartyId: menuItems.length
      ? caseObj?.claimantPartyId
        ? caseObj.claimantPartyId
        : menuItems[0].value
      : "" || "",
    title: caseObj?.title || "",
    description: caseObj?.description || "",
    natureOfDispute: caseObj?.natureOfDispute || "",
    natureOfDisputeOther: caseObj?.natureOfDisputeOther || "",
    preferredLanguage: caseObj?.preferredLanguage || "",
    preferredLanguageOther: caseObj?.preferredLanguageOther || "",
    specialRequirements: caseObj?.specialRequirements || "",
    currencyUnit: caseObj?.currencyUnit || "INR",
    totalClaimValue: caseObj?.totalClaimValue || 0,
    resolutionKind:
      caseObj?.resolutionKind || searchParams.get("caseType") || "negotiation",
    agreement_urls:
      caseObj?.agreement_urls && caseObj.agreement_urls.length
        ? setInitialAgreementUrl(caseObj.agreement_urls)
        : [dummyFileUpload],
    subscriptionKind:
      subscriptionType === "courtreferred" ? "normal" : subscriptionType,
    subscriptionType,
    typeOfArbitration: caseObj?.typeOfArbitration || "domestic",
    emergencyArbitration:
      caseObj?.emergencyFlag === true || caseObj?.emergencyArbitration === "yes"
        ? "yes"
        : "no",
    arbitratorDetailsType:
      caseObj?.disputeKind?.toLowerCase() === "msme" ||
      caseObj?.arbitratorDetailsType === "msme"
        ? "msme"
        : "others",
    arbitrationNotice:
      caseObj.agreement_urls?.find(
        (el) => el?.uploadType === "Arbitration Notice",
      )?.url || "",
    claim_items_data: caseObj?.caseItems?.length
      ? _.map(caseObj?.caseItems, (ci) => ({
          ...ci,
          claimValue: parseFloat(ci.claimValue).toFixed(2),
        }))
      : [initialState] || [initialState],
  };
};

/**
 *@description Function to set the initial agremment url
 * @param {*} urls
 */
export const setInitialAgreementUrl = (urls = []) => {
  if (urls?.length) {
    const agrementUrl = urls
      ?.filter((el) => el?.uploadType !== "Arbitration Notice")
      ?.map((url) => {
        if (typeof url === "string") {
          return {
            uploadType: "",
            url: url || "",
            category: "",
          };
        } else {
          return {
            uploadType: url?.uploadType || "",
            url: url?.url || "",
            category: url?.category,
          };
        }
      });
    return agrementUrl?.length ? agrementUrl : [dummyFileUpload];
  }
  return [dummyFileUpload];
};

/**
 * @description Function to set the initial mediator object
 * @param {*} caseObj
 */
export function setInitialMediator(caseObj) {
  if (caseObj?.requestedMediators?.length) {
    return caseObj?.requestedMediators?.map((el) => {
      return {
        mediatorName: el?.name || "",
        mediatorEmail: el?.email || "",
        mediatorMobile: el?.mobile || "",
        mediatorPostalAddress: el?.postalAddress || "",
        mediatorDocuments: el?.documents || "",
      };
    });
  } else {
    return [
      {
        mediatorName: caseObj?.requestedMediator?.name || "",
        mediatorEmail: caseObj?.requestedMediator?.email || "",
        mediatorMobile: caseObj?.requestedMediator?.mobile || "",
        mediatorPostalAddress: caseObj?.requestedMediator?.postalAddress || "",
        mediatorDocuments: caseObj?.requestedMediator?.documents || "",
      },
    ];
  }
}

/**
 * @description Function to set the dummy file upload object
 * @param {*} values
 */
export const dummyFileUpload = {
  uploadType: "",
  url: "",
  category: "",
};

/**
 * @description Function to set the post payload
 * @param {*} payload
 */
export const setPostPayload = (payload) => {
  payload.subscriptionType =
    payload?.subscriptionType === "courtreferred"
      ? "courtreferred"
      : payload?.subscriptionKind || "normal";
  payload.subscriptionKind =
    payload?.subscriptionType === "courtreferred"
      ? "normal"
      : payload?.subscriptionKind || payload?.subscriptionType || "normal";

  //Total claim value
  payload.totalClaimValue = Number(
    payload.totalClaimValue?.toString()?.split(",")?.join(""),
  );

  //Set agreement url
  payload.agreement_urls = payload.agreement_urls
    ?.filter((el) => el?.url)
    ?.map((el) => {
      return {
        uploadType:
          payload?.resolutionKind === "arbitration" ? el?.uploadType : "",
        category: payload?.resolutionKind === "arbitration" ? el?.category : "",
        url: el?.url,
      };
    });

  if (payload?.resolutionKind === "arbitration" && payload?.arbitrationNotice) {
    payload.agreement_urls.push({
      uploadType: "Arbitration Notice",
      url: payload?.arbitrationNotice,
    });
  }

  if (payload?.resolutionKind !== "arbitration") {
    delete payload.arbitrationType;
  }

  if (payload?.resolutionKind === "negotiation") {
    delete payload.arbitratorDetailsType;
    delete payload.disputeKind;
    delete payload.emergencyArbitration;
    delete payload.emergencyFlag;
    delete payload.natureOfDispute;
    delete payload.natureOfDisputeOther;
    delete payload.preferredLanguage;
    delete payload.preferredLanguageOther;
    delete payload.specialRequirements;
  }

  if (payload?.resolutionKind === "arbitration") {
    payload.emergencyFlag = payload?.emergencyArbitration === "yes";
  } else {
    delete payload.emergencyFlag;
  }
  delete payload.emergencyArbitration;

  if (payload?.resolutionKind !== "negotiation") {
    payload.disputeKind =
      payload?.arbitratorDetailsType === "msme" ? "msme" : "others";
  }

  if (payload?.natureOfDispute === "others") {
    payload.natureOfDispute = payload?.natureOfDisputeOther || "";
  }
  delete payload.natureOfDisputeOther;

  if (payload?.preferredLanguage === "others") {
    payload.preferredLanguage = payload?.preferredLanguageOther || "";
  }
  delete payload.preferredLanguageOther;

  // set the requested mediator object
  if (payload?.arbitratorDetailsType === "msme") {
    payload.requestedMediators = [];
  } else if (
    payload.requestedMediators?.length &&
    payload.requestedMediators[0]?.mediatorName
  ) {
    payload.requestedMediators = payload?.requestedMediators?.map(
      (mediator) => {
        return {
          name: mediator?.mediatorName,
          mobile: mediator?.mediatorMobile,
          email: mediator?.mediatorEmail?.toString().toLowerCase(),
          postalAddress: mediator?.mediatorPostalAddress,
          documents: mediator?.mediatorDocuments,
        };
      },
    );
  } else {
    payload.requestedMediators = [];
  }
  delete payload.arbitratorDetailsType;
  return { ...payload };
};

export const setPostPayloadMediators = (payload) => {
  // set the requested mediator object
  if (payload?.length && payload[0]?.mediatorName) {
    payload.requestedMediators = payload?.map((mediator) => {
      return {
        name: mediator?.mediatorName,
        email: mediator?.mediatorEmail?.toString().toLowerCase(),
        mobile: mediator?.mediatorMobile,
        postalAddress: mediator?.mediatorPostalAddress,
        documents: mediator?.mediatorDocuments,
      };
    });
  } else {
    payload.requestedMediators = [];
  }
  return { ...payload };
};
